import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'app/shared/loading/loading.module';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CarruseladminModule } from '../carruseladmin/carruseladmin.module';
import { CarruselModule } from '../carrusel/carrusel.module';
import { ProductcardModule } from '../productcard/productcard.module';
import { MaintenanceComponent } from './maintenance.component';



const routes: Routes = [{ path: '', component: MaintenanceComponent }];
@NgModule({
  declarations: [MaintenanceComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule, ReactiveFormsModule,
    LoadingModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    CarruseladminModule,
    CarruselModule,
    ProductcardModule
  ],
  entryComponents: [MaintenanceComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  exports: [
    RouterModule,
    MaintenanceComponent
  ]
})
export class MaintenanceModule { }
